import React from "react";
import { FaWhatsapp } from "react-icons/fa"; // requires: npm install react-icons
import { Button } from "./ui";

const CTAWhatsApp = ({
  firstParagraph = "Lassen Sie uns gemeinsam Ihr Porsche-Projekt starten",
  secondParagraph = "Restauration, Motorenbau oder Optimierung",
  buttonText = "Jetzt anfragen",
}) => {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between border border-gray-300 rounded-sm p-6 max-w-5xl mx-auto mt-8">
      <div className="flex flex-col sm:flex-row items-center text-white dark:text-white mb-4 sm:mb-0 text-center sm:text-left">
        <FaWhatsapp className="min-w-24 text-green-500 text-5xl sm:text-6xl mb-2 sm:mb-0 sm:mr-6" />
        <div>
          <p className="text-2xl sm:text-3xl text-[var(--color-secondary)] max-w-4xl leading-relaxed sm:leading-relaxed">
            <strong>{firstParagraph}</strong>
          </p>
          <p className="text-xl sm:text-2xl text-[var(--color-secondary)] max-w-4xl pt-4 sm:pt-4">
            {secondParagraph}
          </p>
        </div>
      </div>
      <Button
        as="a"
        href="https://wa.me/4915756850714"
        target="_blank"
        rel="noopener noreferrer"
        variant="secondary"
        size="large"
        className="w-64 ml-2"
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default CTAWhatsApp;
